import { Button } from 'antd'
import React from 'react'
import { styled } from 'troyfe'

const Blcok = styled.div`
  margin: ${props => props.margin};
  .but {
    width: ${props => (props.width ? `${props.width}px` : '100%')};
    color: #fff;
    background: ${props =>
      props.background ||
      'linear-gradient(to right, rgb(42, 178, 231), #44BB55)'};
    border: none;
    border-color: none;
    /* text-shadow: 0 2px 0 #44BB55; */
  }
`
const CustomButton = props => {
  const { option } = props
  return (
    <Blcok background={option.background} margin={option.margin}>
      <Button className="but" {...option}>
        {option.text || '确认'}
      </Button>
    </Blcok>
  )
}

export default CustomButton
